import {SearchSummary} from './searchSummary';

export class BrokerSearch extends SearchSummary {

    searchResult: any;
    additionalDataAvailable: boolean;

}
